import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CmsConfig } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { provideDefaultConfig } from '../../../core/config';
import { I18nModule } from '../../../core/i18n';
import { MediaModule } from '../../../shared';
import { ActionButtonModule } from '../../../shared/components/action-button';
import { FileUploadModule } from '../../../shared/components/file-upload/file-upload.module';
import { ReactiveFormCheckboxModule } from '../../../shared/components/reactive-forms-input/reactive-form-checkbox/reactive-form-checkbox.module';
import { ReactiveFormInputFieldModule } from '../../../shared/components/reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { ReactiveFormTextareaModule } from '../../../shared/components/reactive-forms-input/reactive-form-textarea';
import { MailFormComponent } from './mail-form.component';

@NgModule({
  imports: [
    CommonModule,
    MediaModule,
    I18nModule,
    ActionButtonModule,
    ReactiveFormsModule,
    NzIconModule,
    ReactiveFormInputFieldModule,
    ReactiveFormCheckboxModule,
    FileUploadModule,
    ReactiveFormTextareaModule,
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSMailFormComponent: {
          component: MailFormComponent,
        },
      },
    }),
  ],
  declarations: [MailFormComponent],
  exports: [MailFormComponent],
})
export class CmsMailFormModule {}
